// ResourcesDropdown.jsx
import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../../../../store/slices/employeeSlice";

const ResourcesDropdown = ({
  index,
  row,
  dropdownRefs,
  handleDropdownChange,
  openDropdownIndex,
  setOpenDropdownIndex,
  assignedPeopleList,
  employeesfinalList,
  setAssignedPeopleList,
  isViewOnly = false,
}) => {
  const dispatch = useDispatch();
  const { employees } = useSelector((state) => state.employees);

  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  const handleResourceToggle = (e) => {
    if (isViewOnly) return;
    e.stopPropagation();
      setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  const [filteredEmployee, setFilteredEmployee] = useState([]);
  const [matchedManager, setMatchedManager] = useState([]);
  useEffect(() => {
    const matchedEmployees = employees?.filter((emp) =>
      row.AssignedManagerEmail.includes(emp.EmpEmail)
    );
    setMatchedManager(matchedEmployees);
  }, [employees, row]);

  useEffect(() => {
    if (row && row.Assignedperson && employeesfinalList.length > 0) {
      //Extract assigned emails
      const assignedEmails = row.Assignedperson.map((p) => p.email);
      //Filter out assigned employees
      const unassignedEmployees = employeesfinalList.filter(
        (emp) => !assignedEmails.includes(emp.EmpEmail)
      );
      // From unassigned, keep only those with customRoles including "operations"
      const unassignedWithOperationsRole = unassignedEmployees.filter((emp) =>
        emp.customRoles?.includes("operations")
      );

      // Get all unique servicetypes from matchedManager array
      const managerServiceTypes = matchedManager.map(m => m.servicetype);

      // Filter unassigned operations employees by any matching manager servicetype
      const filteredByServiceType = unassignedWithOperationsRole.filter(emp =>
        managerServiceTypes.includes(emp.servicetype)
      );
      setFilteredEmployee(filteredByServiceType);
    }
  }, [row, employeesfinalList, matchedManager]);

  const handleResourceChange = (e, group) => {
    e.stopPropagation(); // Keep this
    const isChecked = e.target.checked;
    const fullName = `${group.EmpFirstName} ${group.EmpLastName}`;
    const selectedValue = { name: fullName, email: group.EmpEmail };

    setAssignedPeopleList((prev) => {
      const current = prev[index] || [];
      if (isChecked) {
        const alreadyExists = current.some(
          (item) => item.email === selectedValue.email
        );
        if (!alreadyExists) {
          return { ...prev, [index]: [...current, selectedValue] };
        }
      } else {
        return {
          ...prev,
          [index]: current.filter((item) => item.email !== selectedValue.email),
        };
      }
      return prev;
    });
  };

  return (
    <div className="w-full flex justify-center align-middle items-center">
      <div
        ref={(el) => {
          dropdownRefs.current[index] = el;
        }}
        onClick={() => handleDropdownChange(index)}
        className="relative flex  w-full rounded-md  align-middle items-center my-1 border"
      >
        <ExpandMoreIcon
          color="white"
          className={`absolute right-0 m-auto bg-white ${isViewOnly ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
          onClick={handleResourceToggle}
        />
        <button
          type="button"
          onClick={handleResourceToggle}
          disabled={isViewOnly}
          className={`text-left text-xs text-nowrap overflow-hidden rounded-md p-2 outline-none w-28 ${isViewOnly ? "cursor-not-allowed opacity-50" : ""}`}
        >
          {assignedPeopleList[index]?.length > 0
            ? assignedPeopleList[index]
              .map((item) => item?.name || "Unnamed")
              .join(", ")
            : "Resources"}
        </button>

        {openDropdownIndex === index && (
          <div
            //  onClick={(e) => e.stopPropagation()}
            style={{ zIndex: 999 }}
            className="absolute top-full left-0 w-full cursor-pointer max-h-52 overflow-y-auto bg-gray-100  text-sm border border-gray-300 shadow-lg flex flex-col gap-2"
          >
            {filteredEmployee.length === 0 ? (
              <div className="px-3 py-2 text-xs text-center text-gray-500 bg-white">
                No resources found
              </div>
            ) : (
              filteredEmployee.map((group) => {
                const fullName = `${group.EmpFirstName} ${group.EmpLastName}`;
                const isChecked = assignedPeopleList[index]?.some(
                  (item) => item.email === group.EmpEmail
                );

                return (
                  <label
                    key={group.id}
                    className="flex text-xs text-start px-2 py-1 hover:bg-gray-200 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      value={fullName}
                      checked={isChecked}
                      onChange={(e) => handleResourceChange(e, group)}
                      className="mr-2"
                    />
                    {fullName}
                  </label>
                );
              })
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ResourcesDropdown;
